import axios from "axios";
import {getUserToken} from "../../../../../utils/functions/userToken";
import {apiUrlActiveMultipliers} from "./apiUrlMultipliers";

export const deleteBiddingRows = async (accountId, tabType, rowIds, hotelsOrGroup) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${apiUrlActiveMultipliers['delete'][hotelsOrGroup][tabType]}${accountId}/`,
            { rowIds },
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.errorMessage || "Failed to fetch delete bidding";
        return { success: false, error: errorMessage };
    }
};

export const deleteKayakBidding = async ({ accountId, tabType, idMultiplier, hotelsOrGroup }) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${apiUrlActiveMultipliers['delete'][hotelsOrGroup][tabType]}${accountId}/`,
            { idMultiplier },
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.errorMessage || "Failed to fetch delete bidding";
        return { success: false, error: errorMessage };
    }
};

